import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";
import { FaWhatsapp } from "react-icons/fa";

function Contact() {
  return (
    <section>
      <Container fluid className="contact-section">
        <Particle />
        <Container>
            <h1 className="project-heading">
                <strong className="purple"> Contactanos</strong>
            </h1>
          <Row>
            <Col >
                <Card>
                    <Card.Body>
                        <p className="contact-about-body">
                            <b>NAYELI RUBIO</b> <br/>
                            Ejecutiva de Ventas <br/>
                            nayeli.rubio@naansoluciones.mx <br/>
                            naan_contacto@naansoluciones.mx <br/>
                            GDL,MX.
                        </p>
                        <p style={{ fontSize:"2em"}}> Escribenos por Whatsapp.
                            <a
                                href="https://wa.me/523323709483/?text=Estoy%20interesado%20en%20algun%20producto%20de%20CONTPAQi.%20%C2%BFMe%20puedes%20ayudar%3F"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour-whats  sale-social-icons"
                            >
                                <FaWhatsapp />
                            </a>
                        </p>
                    </Card.Body>
                </Card>              
              
            </Col>

          </Row>
        </Container>
      </Container>
     
    </section>
  );
}

export default Contact;
